/**
 * Remove duplicatas por `id`, preservando a ordem da primeira ocorrência.
 *
 * Uma passada com `Set`: o idioma `filter((item, i, self) => i ===
 * self.findIndex(...))` é O(n²) e, em lista paginada, re-varre tudo o que já
 * estava na tela a cada página nova.
 */
export const dedupeById = <T extends { id: string }>(
  items: readonly T[],
): T[] => {
  const seen = new Set<string>()
  const unique: T[] = []

  for (const item of items) {
    if (seen.has(item.id)) continue
    seen.add(item.id)
    unique.push(item)
  }

  return unique
}
